module.exports = __webpack_public_path__ + "img/h-dz1.305161a1.png";